// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.iw9EWovBZ8 {
  width: 369px;
  padding: 4px;
  box-shadow: 0 0 2px 2px rgba(0, 0, 0, 0.06);
  float: left;
  background: #fff;
}
.iw9EWovBZ8 h4 {
  line-height: 3em;
}
.iw9EWovBZ8 .NmNOHbhp3_ {
  float: left;
  width: 100%;
}
.iw9EWovBZ8 .YylUaVFF3x {
  height: 40px;
  width: 60px;
  float: left;
  display: inline-block;
  min-height: 0;
  border-radius: 0;
  margin-bottom: 0;
  position: relative;
}
.iw9EWovBZ8 .YylUaVFF3x:hover {
  cursor: pointer;
}
.iw9EWovBZ8 .YylUaVFF3x:hover:after {
  position: absolute;
  content: "";
  z-index: 10;
  height: 40px;
  width: 60px;
  top: 0;
  left: 0;
  background: rgba(255, 255, 255, 0.3);
}
.dqSB5pl5qL .Gi6kT9V81m:focus {
  outline: none;
}
.dqSB5pl5qL .Gi6kT9V81m.i7hB180A9d.o8PO0jrvlA {
  background: #375A88;
}
.dqSB5pl5qL .Gi6kT9V81m.i7hB180A9d.o8PO0jrvlA span {
  color: #fff;
}
.dqSB5pl5qL .o8PO0jrvlA {
  background: #F5F4F9;
  border: 1px solid rgba(0, 0, 0, 0.06);
  color: rgba(0, 0, 0, 0.2);
}
.dqSB5pl5qL .o8PO0jrvlA:hover {
  background: #4F5157;
  color: #fff;
  border: 1px solid rgba(0, 0, 0, 0.06);
}
.dqSB5pl5qL input {
  height: 38px;
  min-width: 220px;
}
.YylUaVFF3x.mCOyKy3vwS {
  background: #410102;
}
.YylUaVFF3x.gEabrwQpVY {
  background: #911318;
}
.YylUaVFF3x.UzImQuPbD9 {
  background: #D8293B;
}
.YylUaVFF3x.n9X3tICuWp {
  background: #F2373C;
}
.YylUaVFF3x.Z4afLQPQiF {
  background: #FC4448;
}
.YylUaVFF3x.tsPQPjkbQt {
  background: #ED535E;
}
.YylUaVFF3x.KmhxQIx4AN {
  background: #E34926;
}
.YylUaVFF3x.LIrKAOXfTE {
  background: #FC562B;
}
.YylUaVFF3x.CVT6Mv9seF {
  background: #FC6722;
}
.YylUaVFF3x.iltBFY5UEp {
  background: #FD7F24;
}
.YylUaVFF3x.EJbEsIJzln {
  background: #FD8D26;
}
.YylUaVFF3x.GThSOZh9Vd {
  background: #EC9C3E;
}
.YylUaVFF3x.fKOYcXks3_ {
  background: #0e673a;
}
.YylUaVFF3x.AUTjnCu7BQ {
  background: #208740;
}
.YylUaVFF3x.Pvrpd1x_tK {
  background: #239718;
}
.YylUaVFF3x.hu4acKMH2d {
  background: #55A84D;
}
.YylUaVFF3x.ClwNt1jnCJ {
  background: #4BBE5A;
}
.YylUaVFF3x.xOIP6GIzo2 {
  background: #0CCA6A;
}
.YylUaVFF3x.nNUZjxHLBR {
  background: #0A3C64;
}
.YylUaVFF3x.MRbErLlvKf {
  background: #0d487a;
}
.YylUaVFF3x.EOXiylbKW2 {
  background: #10538d;
}
.YylUaVFF3x.ZZ6VsuOtQJ {
  background: #115A99;
}
.YylUaVFF3x.cyAcMeEagB {
  background: #3387E2;
}
.YylUaVFF3x.vDptfM73J4 {
  background: #1BA9CF;
}
.YylUaVFF3x.ehSI8WhmNK {
  background: #d27c02;
}
.YylUaVFF3x.xAbFWe6Qxw {
  background: #fb9402;
}
.YylUaVFF3x.JKe93CtPHI {
  background: #FD9B30;
}
.YylUaVFF3x.bzOQ_XidcJ {
  background: #FDBE2D;
}
.YylUaVFF3x.OI2VUj8RSS {
  background: #FED831;
}
.YylUaVFF3x.V1SFqtQKns {
  background: #FFFD38;
}
.YylUaVFF3x.Ut4w2THtdW {
  background: #2D215C;
}
.YylUaVFF3x.tCqlimoCY0 {
  background: #483C83;
}
.YylUaVFF3x.EoCDgMDNxQ {
  background: #58518d;
}
.YylUaVFF3x.Cy0SM0Qpz5 {
  background: #7068A9;
}
.YylUaVFF3x._BIidf4d9u {
  background: #7f78b2;
}
.YylUaVFF3x.E88W6WzuuE {
  background: #8f88bc;
}
.YylUaVFF3x.oH_wfSoAs7 {
  background: #000;
}
.YylUaVFF3x.jHSELbwKFP {
  background: #282626;
}
.YylUaVFF3x.ek5P2YCxEk {
  background: #242222;
}
.YylUaVFF3x.FLmHUk9crK {
  background: #353838;
}
.YylUaVFF3x.KDcV7KpmTe {
  background: #666;
}
.YylUaVFF3x.fC5ckvphnt {
  background: #999;
}
.tnGWgVz_rV {
  background: none;
  margin-top: 120px;
  position: relative;
  margin-left: 10px;
}
.tnGWgVz_rV .colljgFWkv {
  display: none;
}
.luVjUvuqxC .KfTQGWFQEt {
  display: flex;
  justify-content: space-between;
  margin: 16px 28px;
}
.luVjUvuqxC .KfTQGWFQEt .xPwDfZi31H {
  display: flex;
}
.luVjUvuqxC .KfTQGWFQEt .OFGtjJucUy {
  flex: 1;
}
.luVjUvuqxC .KfTQGWFQEt .YIPTNJqKxV:hover {
  background: #488D29;
}
.luVjUvuqxC .KfTQGWFQEt .m1hs2a6OBH {
  background: #B3B3B3;
  background-color: #B3B3B3;
  cursor: initial;
}
.luVjUvuqxC .KfTQGWFQEt .m1hs2a6OBH:hover {
  background: #B3B3B3;
  background-color: #B3B3B3;
}
.luVjUvuqxC .KfTQGWFQEt .xPwDfZi31H .m6rjQQ89Kp {
  display: flex;
  align-items: center;
  margin-right: 42px;
}
.luVjUvuqxC .KfTQGWFQEt .xPwDfZi31H .OUHV_qYcdl input {
  text-align: center;
  border-radius: 3px;
}
.luVjUvuqxC .KfTQGWFQEt .xPwDfZi31H .OUHV_qYcdl input:checked {
  background-color: #00739a;
}
.luVjUvuqxC .KfTQGWFQEt .xPwDfZi31H .OUHV_qYcdl::before {
  font-size: 10px;
  vertical-align: middle;
}
.luVjUvuqxC .KfTQGWFQEt .xPwDfZi31H .aTR3XTu9Tj {
  font-size: 10px !important;
  font-weight: bold;
  min-width: 186px;
}
.luVjUvuqxC .KfTQGWFQEt .FlLwTNVpDZ:hover {
  background: #e5e5e5;
  color: #212121;
}
.luVjUvuqxC .KfTQGWFQEt .jEuTOeI6OO {
  font-weight: initial;
  height: 32px;
}
.luVjUvuqxC .KfTQGWFQEt .jEuTOeI6OO .sq2d_YbxF8.NQyZuYfUp1 {
  margin-left: 4px;
}
.luVjUvuqxC .KfTQGWFQEt .jEuTOeI6OO .sq2d_YbxF8.E0xVxbuNWR {
  margin-right: 4px;
}
.luVjUvuqxC .KfTQGWFQEt .jEuTOeI6OO .sq2d_YbxF8.sq2d_YbxF8 .zgZoU3M_zT.zgZoU3M_zT {
  font-size: 14px;
  font-weight: 100;
}
.luVjUvuqxC .KfTQGWFQEt .ICcDUKwBug {
  display: flex;
  align-items: baseline;
}
.luVjUvuqxC .KfTQGWFQEt .ICcDUKwBug .cfSWN4RGYA {
  display: flex;
  align-items: baseline;
  cursor: pointer;
  margin-left: 32px;
  text-transform: uppercase;
}
.luVjUvuqxC .KfTQGWFQEt .ICcDUKwBug .Nyp3goX6oX {
  font-size: 12px;
  margin-right: 8px;
}
.luVjUvuqxC .KfTQGWFQEt .ICcDUKwBug .ti2GSc19SI:hover {
  text-decoration: underline;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"color-picker": `iw9EWovBZ8`,
	"color-row": `NmNOHbhp3_`,
	"color-tile": `YylUaVFF3x`,
	"picker-component": `dqSB5pl5qL`,
	"picker-element": `Gi6kT9V81m`,
	"active": `i7hB180A9d`,
	"btn": `o8PO0jrvlA`,
	"red-1": `mCOyKy3vwS`,
	"red-2": `gEabrwQpVY`,
	"red-3": `UzImQuPbD9`,
	"red-4": `n9X3tICuWp`,
	"red-5": `Z4afLQPQiF`,
	"red-6": `tsPQPjkbQt`,
	"orange-1": `KmhxQIx4AN`,
	"orange-2": `LIrKAOXfTE`,
	"orange-3": `CVT6Mv9seF`,
	"orange-4": `iltBFY5UEp`,
	"orange-5": `EJbEsIJzln`,
	"orange-6": `GThSOZh9Vd`,
	"green-1": `fKOYcXks3_`,
	"green-2": `AUTjnCu7BQ`,
	"green-3": `Pvrpd1x_tK`,
	"green-4": `hu4acKMH2d`,
	"green-5": `ClwNt1jnCJ`,
	"green-6": `xOIP6GIzo2`,
	"blue-1": `nNUZjxHLBR`,
	"blue-2": `MRbErLlvKf`,
	"blue-3": `EOXiylbKW2`,
	"blue-4": `ZZ6VsuOtQJ`,
	"blue-5": `cyAcMeEagB`,
	"blue-6": `vDptfM73J4`,
	"yellow-1": `ehSI8WhmNK`,
	"yellow-2": `xAbFWe6Qxw`,
	"yellow-3": `JKe93CtPHI`,
	"yellow-4": `bzOQ_XidcJ`,
	"yellow-5": `OI2VUj8RSS`,
	"yellow-6": `V1SFqtQKns`,
	"purple-1": `Ut4w2THtdW`,
	"purple-2": `tCqlimoCY0`,
	"purple-3": `EoCDgMDNxQ`,
	"purple-4": `Cy0SM0Qpz5`,
	"purple-5": `_BIidf4d9u`,
	"purple-6": `E88W6WzuuE`,
	"black-1": `oH_wfSoAs7`,
	"black-2": `jHSELbwKFP`,
	"black-3": `ek5P2YCxEk`,
	"black-4": `FLmHUk9crK`,
	"black-5": `KDcV7KpmTe`,
	"black-6": `fC5ckvphnt`,
	"picker-theme": `tnGWgVz_rV`,
	"arrow-regular": `colljgFWkv`,
	"modal-footer": `luVjUvuqxC`,
	"modal-footer__root": `KfTQGWFQEt`,
	"footer-right": `xPwDfZi31H`,
	"footer-right__item": `OFGtjJucUy`,
	"footer-right__item--base": `YIPTNJqKxV`,
	"footer-right__item--disable": `m1hs2a6OBH`,
	"notify-reviewer": `m6rjQQ89Kp`,
	"notify-reviewer__icon": `OUHV_qYcdl`,
	"notify-reviewer__label": `aTR3XTu9Tj`,
	"footer-left": `FlLwTNVpDZ`,
	"modal-footer__btn": `jEuTOeI6OO`,
	"footer-btn__icon": `sq2d_YbxF8`,
	"footer-btn__icon--right": `NQyZuYfUp1`,
	"footer-btn__icon--left": `E0xVxbuNWR`,
	"footer-btn__icon--lg": `zgZoU3M_zT`,
	"modal-footer__left": `ICcDUKwBug`,
	"delete-template": `cfSWN4RGYA`,
	"delete-template__icon": `Nyp3goX6oX`,
	"delete-template__text": `ti2GSc19SI`
};
export default ___CSS_LOADER_EXPORT___;
